export default "__VITE_ASSET__CDv6tu7A__"